/*! @pentacode/ui v0.1.0 */
import { t as e } from "./bar-DYRrVa7n.js";
import { r as t } from "./scene-8VKOJsMP.js";
import { n, r } from "./rule-BbeXdbtC.js";
import { t as i } from "./stack-Bwmp8HrU.js";
import { r as a } from "./theme-BDdgxk0M.js";
import { a as o, c as s, d as c, i as l, l as u, r as d, s as f, u as p } from "./shared-CfvkKPnq.js";
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/group.js
function m(e = {}) {
	return {
		type: "group",
		...e
	};
}
// src/charts/presets/bar.ts
function h(h, { stacked: g = !1, line: _ = [], ...v } = {}) {
	let { format: y = f, xFormat: b, valueLabel: x, colors: S, legend: C, yAxis: w, highlight: T } = v, E = u([...h, ..._]), D = s, O = g ? i({ order: u(h) }) : m({ padding: .15 });
	return t({
		theme: a,
		marks: [
			e(h, {
				...D,
				layout: O,
				inset: 2,
				radius: g ? void 0 : { end: 4 }
			}),
			..._.length ? [r(_, {
				...D,
				strokeWidth: 2,
				points: !0,
				curve: p
			})] : [],
			n([0])
		],
		scales: {
			x: d(h, "band", b),
			y: c(y, x, w)
		},
		color: l(E, S, C, T),
		focus: "group-x",
		focusRing: !1,
		tooltip: o(h, y, b)
	});
}
export { m as n, h as t };

//# sourceMappingURL=bar-BK9D38DF.js.map